import MainLayout from 'components/layout/MainLayout';
import BlogArticle from 'components/blog/BlogArticle';
import { ASSET_PREFIX } from 'utils/constants';
import { NextSeo } from "next-seo";
import Link from "next/link";

const EpicTripsForTwoUnder500PoundsArticle = () => {
  const IMAGE_DIRECTORY = `${ASSET_PREFIX}/images/blog/articles/epic-trips-under-500`;

  return (
    <MainLayout>
      <NextSeo
        title='5 Epic Trips For Two Under £500 | DAYMADE'
        description="Summer 2020 isn't cancelled. Together with LuckyTrip, we have listed 5 amazing trips for 2, all under £500 (flights and hotel included!)."
        openGraph={{
          title: '5 Epic Trips For Two Under £500 | DAYMADE',
          description: "Summer 2020 isn't cancelled. Together with LuckyTrip, we have listed 5 amazing trips for 2, all under £500 (flights and hotel included!).",
          type: 'article',
          url: 'https://www.daymade.co.uk/blog/5-epic-trips-for-two-under-500-pounds',
          images: [{
            url: `${IMAGE_DIRECTORY}/hero.jpg`,
            alt: 'Smiling woman eating ice cream in front of colourfully painted wall'
          }]
        }}
        // additionalMetaTags={[{
        //   name: 'keywords',
        //   content: 'win a holiday, trips for 2, trips under £500, budget travel, competition, holiday raffle, daymade, triphunters, luckytrip, guaranteed winner, Reykjavik, iceland, sintra, portugal, budapest, hungary, krakow, poland, corfu, greece, foodie, warehouse parties, cool bars, europe travel, cheap trips, summer 2020, holiday 2020, epic trips, getaway, couple travel, friends trip'
        // }]}
      />

      <BlogArticle
        imageDirectory={IMAGE_DIRECTORY}
        heroAltText='Smiling woman eating ice cream in front of colourfully painted wall'
      >
        <>
          <h1 style={{ fontSize: '1.6em' }}>
            5 <strong>epic trips</strong> for two under £500
          </h1>

          <p className='subheading'>
            Summer 2020 isn't cancelled
          </p>

          <div className='separator' style={{ width: '80%', marginTop: 0 }} />

          <p>
            <span className='bigFirstLetter'>A</span>s travel restrictions are slowly lifted, it's time to explore your travel options! And what better way to do it than use LuckyTrip's super handy travel inspiration app which allows you to set a budget and let the app do the planning for you. This month's {''}
            <Link href='/raffle/travel'>
              <a style={{ fontWeight: 'bold', margin: 0 }}>
                Travel Raffle
              </a>
            </Link>
            {''} is a LuckyTrip exclusive, meaning we are giving away a gift card worth £500 which covers an amazing trip for 2. The guaranteed winner will have plenty of choice, but to get the dreaming started, here are 5 epic trips for 2 people that you can go on with your gift card.
          </p>

          <h4>
            <strong>SINTRA</strong>, PORTUGAL
          </h4>

          <p>
            By far the most magical town in Portugal, this gem should be on top of your summer bucketlist. With a variety of Gothic, Egyptian, Moorish and Renaissance style castles, beautiful wild nature and sandy beaches, it is a highly Instagrammable destination. Don't forget to have a mouthwatering Queijada for breakfast, lunch and dinner. Make the most out of your time in Portugal by eating as many of these mini sugar glazed cheesecakes as you can 😉
          </p>

          <a href='https://luckytrip.co.uk/post/750' target='_blank' style={{ fontWeight: 'bold', margin: 0 }}>
            View LuckyTrip Post →
          </a>

          <img
            src={`${IMAGE_DIRECTORY}/secondary4.jpg`}
            alt='Pena Palace in Portugal — a bright yellow and red painted castle on top of a hill'
            className='singleBlogImage'
          />

          <h4>
            <strong>REYKJAVIK</strong>, ICELAND
          </h4>

          <p>
            As one of the first destinations to open its borders, Iceland is an unlikely hot spot this summer. Where tourists usually come for the Northern Lights and Christmas vibes, it has now turned into an epic getaway to escape the dreadful British heatwaves. Who'd have known! Become best friends with the locals — the whales and arctic foxes hidden in the icy peaks — and find your zen in the hot thermals and Blue Lagoons. A desperately needed break from 2020.
          </p>

          <a href='https://luckytrip.co.uk/post/820' target='_blank' style={{ fontWeight: 'bold', margin: 0 }}>
            View LuckyTrip Post →
          </a>

          <h4>
            <strong>BUDAPEST</strong>, HUNGARY
          </h4>

          <p>
            Want to eat and drink your way through a new city without spending tons of money? Budapest is your best bet. It is a budget-friendly city with a bustling nightlife filled with amazing local restaurants and the best European bars. Even Michelin star restaurants are affordable! Enjoy a weekend of eating, drinking and last but not least: unforgettable spa visits.
          </p>

          <a href='https://luckytrip.co.uk/post/979' target='_blank' style={{ fontWeight: 'bold', margin: 0 }}>
            View LuckyTrip Post →
          </a>

          <div className='doubleImageContainer'>
            <img
              src={`${IMAGE_DIRECTORY}/secondary2.jpg`}
              alt='Arial shot of the Danube River flowing through Budapest'
              className='doubleBlogImage'
            />

            <img
              src={`${IMAGE_DIRECTORY}/secondary1.jpg`}
              alt='Man cycling through the streets of Krakow'
              className='doubleBlogImage'
              style={{
                objectPosition: 'bottom'
              }}
            />
          </div>

          <h4>
            <strong>KRAKOW</strong>, POLAND
          </h4>

          <p>
            Combine culture and history with a visit to Poland's most interesting city: Krakow. Visit the Jewish Quarter Kazimierz (also dubbed Krakow's Hackney) for the best Polish restaurants, coolest bars and edgy warehouse parties. Feast on Polish dumplings and Krakow bagels and don't forget to read up on all the historical sights that Krakow has to offer to make this trip truly worthwhile and offer new perspectives.
          </p>

          <a href='https://luckytrip.co.uk/post/644' target='_blank' style={{ fontWeight: 'bold', margin: 0 }}>
            View LuckyTrip Post →
          </a>

          <h4>
            <strong>CORFU</strong>, GREECE
          </h4>

          <p>
            If there's any place that will truly take our mind off things, it has to be a Greek island. White beaches, blue waters, good food and hot weather? I'll drink a Sambuca to that. But not too many because well, we've all been there and don't necessarily want to get back there. Just us? Ok never mind.
          </p>

          <a href='https://luckytrip.co.uk/post/1074' target='_blank' style={{ fontWeight: 'bold', margin: 0 }}>
            View LuckyTrip Post →
          </a>

          <img
            src={`${IMAGE_DIRECTORY}/secondary3.jpg`}
            alt='arial shot from cliff-top of island beach with deep, vibrant blue waters'
            className='singleBlogImage'
          />

          <p>
            Summer 2020 cancelled? We don't think so! Explore, but stay safe. {''}
            <Link href='/raffle/travel'>
              <a style={{ fontWeight: 'bold', margin: 0 }}>
                Join our LuckyTrip x DAYMADE raffle
              </a>
            </Link>
            {''} now for a chance to win a holiday.
          </p>
        </>
      </BlogArticle>
    </MainLayout>
  );
};

export default EpicTripsForTwoUnder500PoundsArticle;
